var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: { height: 500 + "px" } }, [
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("设备名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("label", { staticClass: "mr20" }, [
          _vm._v(_vm._s(_vm.shopDeviceSvcSubNoInfo.title || ""))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("系统编号")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("label", { staticClass: "mr20" }, [
          _vm._v(_vm._s(_vm.shopDeviceSvcSubNoInfo.tmpNo || ""))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout mt10" },
      [
        _c(
          "el-table",
          {
            attrs: { data: _vm.servcWorkVoucherList, border: "", height: "400" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "servcReqVoucher.no",
                label: "请求单号",
                width: "160",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "servcReqVoucher.requestTime",
                label: "请求时间",
                width: "160",
                align: "center",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "servcReqVoucher.servcName",
                label: "请求服务",
                width: "120",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "servcReqVoucher.requestDesc",
                label: "请求描述",
                width: "150",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "servcReqVoucher.troubleDesc",
                label: "问题描述",
                width: "150",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "报修图片",
                width: "90",
                align: "center",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.servcWorkRepairImgFileList != null &&
                      rows.row.servcWorkRepairImgFileList.length > 0
                        ? _c(
                            "span",
                            _vm._l(
                              rows.row.servcWorkRepairImgFileList,
                              function(img) {
                                return _c("img", {
                                  attrs: { src: img.fileBrowseUrl }
                                })
                              }
                            )
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "no",
                label: "工单编号",
                width: "170",
                align: "center",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "紧急状态",
                prop: "emgLevel",
                width: "80",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c(
                        "span",
                        {
                          class:
                            rows.row.emgLevel == 0
                              ? "font-green"
                              : rows.row.emgLevel == 1
                              ? "font-orange"
                              : "font-red"
                        },
                        [_vm._v(_vm._s(_vm.emgLevelMap[rows.row.emgLevel]))]
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "modelSpec",
                label: "工单状态",
                width: "100",
                align: "center",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.invalid
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("已作废")
                          ])
                        : rows.row.close
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("已关闭")
                          ])
                        : _c("span", { staticClass: "font-black" }, [
                            _vm._v(_vm._s(_vm.workAssignState[rows.row.state]))
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              staticClass: "align-left",
              attrs: { width: "80", label: "是否评价" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.evalFlag ? _c("span", [_vm._v("是")]) : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "chargeItemNames",
                label: "服务项目",
                width: "130",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "repairTypeName",
                label: "维修类型",
                width: "100",
                align: "center",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "faultTypeName",
                label: "故障类型",
                width: "100",
                align: "center",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "faultDesc",
                label: "故障描述",
                width: "150",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "维修图片",
                width: "90",
                align: "center",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.servcWorkImgFileList != null &&
                      rows.row.servcWorkImgFileList.length > 0
                        ? _c(
                            "span",
                            _vm._l(rows.row.servcWorkImgFileList, function(
                              img
                            ) {
                              return _c("img", {
                                attrs: { src: img.fileBrowseUrl }
                              })
                            })
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.totalCount > 0
      ? _c(
          "div",
          { staticClass: "block pagination-layout" },
          [
            _c("el-pagination", {
              staticClass: "mt10",
              attrs: {
                background: "",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount,
                layout: "total, sizes, prev, pager, next, jumper"
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f90aff88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f90aff88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/DeviceRepairRec.vue
// module id = 1863
// module chunks = 1